<template>
  <div class="gfeApprovalTable">
    <q-pull-to-refresh @refresh="refresh" class="pullRefresh">
      <DataCard
        :data="allFilters"
        :fields="fields"
        :actions="actions"
        @approve="approveGFE"
        @reject="rejectGFE"
        @cardClick="detailGFE"
        @filterR="filterBySupplierName"
        @filterB="filterByBranchCode"
        filterData
        v-if="cards"
      />
    </q-pull-to-refresh>
    <div class="RejectionReason">
      <q-dialog v-model="modalReason" persistent square full-width>
        <q-card class="bg-white">
          <q-card-section>
            <div class="text-h6">Rejeitar Tabela GFE</div>
            <div class="text-subtitle2">
              Favor informar o motivo da rejeição:
            </div>
          </q-card-section>
          <q-card-section>
            <q-input
              v-model="descriptionRejection"
              type="textarea"
              label="Descrição do Motivo"
              outlined
            />
          </q-card-section>
          <q-card-section>
            <div class="row justify-evenly q-mb-xl">
              <div class="col-auto">
                <q-btn
                  color="grey-8"
                  label="Cancelar"
                  @click="modalReason = false"
                />
              </div>
              <div class="col-auto">
                <q-btn color="red" label="Rejeitar" @click="confirmReject" />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DataCard from "../../components/DataCard";
import removeCharSpecial from "../../helpers/removerCharSpecial";

export default {
  components: {
    DataCard
  },
  data() {
    return {
      fields: [
        {
          field: "carrierName",
          label: "",
          type: "string",
          class: "text-bold"
        },
        {
          field: "tableDescription",
          label: "",
          type: "string",
          class: "text-caption text-bold"
        },
        { field: "", label: "", type: "separator" },
        {
          field: "branch",
          label: "",
          type: "string",
          class: "text-body2"
        },
        {
          field: "tableGFE",
          label: "",
          type: "string",
          class: "text-overline"
        },
        {
          field: "tableMother",
          label: "",
          type: "string",
          class: "text-overline"
        }
      ],
      actions: [
        {
          label: "Aprovar",
          color: "green",
          icon: "check",
          eventEmit: "approve"
        },
        { label: "Rejeitar", color: "red", icon: "block", eventEmit: "reject" }
      ],
      filterWebR: null,
      filterWebB: null,
      filterR: sessionStorage.filterWebR,
      filterB: sessionStorage.filterWebB,
      cards: true,
      modalReason: false,
      descriptionRejection: null,
      gfeSelected: null
    };
  },
  computed: {
    ...mapState("gfeApprovalTable", ["gfe"]),

    allFilters() {
      //~> Declarando variável que armazenará o Retorno das requisições
      let gfe = this.gfe;

      switch (sessionStorage.sortWeb) {
        case "sSmLg":
          gfe.sort((a, b) => a.amountOfOrder - b.amountOfOrder);
          break;
        case "sLgSm":
          gfe.sort((a, b) => b.amountOfOrder - a.amountOfOrder);
          break;
        case "sNewOld":
          gfe.sort((a, b) => b.issueDate - a.issueDate);
          break;
        case "sOldNew":
          gfe.sort((a, b) => a.issueDate - b.issueDate);
          break;
        default:
          break;
      }

      if (this.filterR) {
        gfe = gfe.filter(order => {
          return (
            order.tableCode
              .toUpperCase()
              .trim()
              .indexOf(this.filterR.toUpperCase().trim()) >= 0 ||
            order.carrierName
              .toUpperCase()
              .trim()
              .indexOf(this.filterR.toUpperCase().trim()) >= 0
          );
        });
      }

      if (this.filterB) {
        if (sessionStorage.filterWebB) {
          gfe = gfe.filter(ord => {
            return (
              ord.branchCode.trim().indexOf(sessionStorage.filterWebB.trim()) >=
              0
            );
          });
        } else {
          gfe = gfe.filter(ord => {
            return ord.branchCode.trim().indexOf(this.filterB.trim()) >= 0;
          });
        }
      }

      return gfe.map(order => {
        if (order.id == "nch7OFgCuoBSptP1ZKqd") {
          console.log(order.negociations);
        }
        return {
          id: order.id,
          carrier: `${order.carrierIdFed} - ${order.carrierName.toUpperCase()}`,
          carrierIdFed: order.carrierIdFed,
          carrierName: order.carrierName,
          branch: `${order.branchCode} - ${order.branchName.toUpperCase()}`,
          tableCode: order.tableCode,
          tableGFE: `Tabela: ${order.tableCode}`,
          typeTable: order.typeTable,
          tableDescription: order.tableDescription,
          tableMother: `Tabela Mãe: ${
            order?.tableMother == "S" ? "Sim" : "Não"
          }`,
          negociations: order.negociations,
          linkedTable: order.linkedTable,
          dateNegociation: order.dateNegociation
        };
      });
    }
  },
  methods: {
    ...mapActions("gfeApprovalTable", ["getGFE", "approvesRejectsGFETable"]),
    ...mapMutations("shared", ["setNotification"]),
    approveGFE(gfe) {
      this.sendResponse(gfe, "approved", "APROVAR", "text-green");
    },
    rejectGFE(gfe) {
      this.gfeSelected = gfe;
      this.modalReason = true;
    },
    sendResponse(gfe, response, text, classMessage) {
      this.$q
        .dialog({
          title: `Confirmação`,
          message: `Deseja realmente <span class="${classMessage}">${text}</span> a Tabela ${gfe.tableCode}?`,
          html: true,
          ok: {
            push: true,
            color: "green",
            label: "Sim"
          },
          cancel: {
            push: true,
            color: "red",
            label: "Não"
          },
          persistent: true
        })
        .onOk(async () => {
          try {
            const reasonReject =
              response === "rejected"
                ? removeCharSpecial(this.descriptionRejection)
                : "approved";
            await this.approvesRejectsGFETable({
              gfe,
              response,
              reasonReject
            });
            this.setNotification({
              message: "Resposta enviada com sucesso.",
              color: "green",
              position: "top"
            });
            this.getGFE();
          } catch (error) {
            this.setNotification({
              message: error.message,
              color: "red",
              position: "top"
            });
          }
        });
    },
    confirmReject() {
      if (String(this.descriptionRejection).trim().length < 8) {
        return this.$q.dialog({
          title: "Cicopal Aprova",
          message: "Favor detalhar o motivo da Rejeição desta tabela!"
        });
      }

      this.sendResponse(this.gfeSelected, "rejected", "REJEITAR", "text-red");
      this.modalReason = false;
    },
    detailGFE(gfeId) {
      console.warn(gfeId);
      this.$router.push({
        name: "gfeDetail",
        params: { gfeId }
      });
    },
    filterBySupplierName(filterR) {
      this.filterR = filterR;
    },
    filterByBranchCode(filterB) {
      if (sessionStorage.filterWebB && !filterB) {
        this.filterB = sessionStorage.filterWebB;
      } else {
        this.filterB = filterB;
        sessionStorage.setItem("filterWebB", filterB);
      }
    },
    async refresh(done) {
      await this.getGFE();
      done();
    }
  },
  created() {
    this.getGFE();
  }
};
</script>
<style lang="scss">
.gfeApprovalTable {
  width: 100%;
}
</style>
